export const FETCH_MARUTI = 'FETCH_MARUTI'
export const FETCHED_MARUTI = 'FETCHED_MARUTI'
export const SEARCH_MARUTI = 'SEARCH_MARUTI'
export const STORE_SEARCH_MARUTI_RESULT = 'STORE_SEARCH_MARUTI_RESULT'
export const REPOST_REDISID = 'REPOST_REDISID'
export const FILTER_ITEMS = 'FILTER_ITEMS'
export const PULL_OLD_SYNC_STATUS = 'PULL_OLD_SYNC_STATUS'
export const FETCHED_PULL_OLD_SYNC_STATUS = 'FETCHED_PULL_OLD_SYNC_STATUS'
export const SYNC_UTD = 'SYNC_UTD'
export const SYNCED_UTD = 'SYNCED_UTD'
export const NOTIFICATION_DONE_ITEM='NOTIFICATION_DONE_ITEM'

